import { useParams } from 'react-router-dom'

import { SaleInvoiceDetailDocumentsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import SaleInvoiceDocuments from 'modules/finance/components/Invoices/SaleInvoiceDocuments'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SaleInvoiceDetailDocumentsPage = () => {
  const { invoiceId } = useParams()

  const { data, error, loading } = useQuery(SaleInvoiceDetailDocumentsPageDocument, {
    variables: {
      id: String(invoiceId),
    },
  })

  const canManageSales = data?.finance?._policies?.financialDocumentsManageSales?.can ?? false
  const file = data?.finance?.financialDocument?.file
  const complianceOutputFiles = data?.finance?.financialDocument?.complianceOutputFiles ?? []

  const files = [file, ...complianceOutputFiles].filter((f) => f !== undefined && f !== null)

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      error={error}
      loading={loading}
      authorized={canManageSales}
    >
      <SaleInvoiceDocuments files={files} />
    </ResponsivePage.Body>
  )
}

export default SaleInvoiceDetailDocumentsPage
